import { AccrediblePaginationModule } from '@accredible-frontend-v2/components/pagination';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatLegacyProgressSpinnerModule as MatProgressSpinnerModule } from '@angular/material/legacy-progress-spinner';
import { RouterModule, Routes } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { LetDirective } from '@ngrx/component';
import { ProfileListCardModule } from './components/profile-list-card/profile-list-card.module';
import { ProfileListFiltersModule } from './components/profile-list-filters/profile-list-filters.module';
import { ProfileListHeaderModule } from './components/profile-list-header/profile-list-header.module';
import { ProfileListNoResultsComponent } from './components/profile-list-no-results/profile-list-no-results.component';
import { ProfileListSearchSortModule } from './components/profile-list-search-sort/profile-list-search-sort.module';
import { ProfileListContainer } from './profile-list.container';
import { FilterService } from './services/filter.service';
import { SpotlightProfilesStoreModule } from './store/spotlight-profiles/spotlight-profiles-store.module';

const routes: Routes = [
  {
    path: '',
    component: ProfileListContainer,
  },
];

const MATERIAL_MODULES = [MatIconModule, MatButtonModule, MatProgressSpinnerModule];

@NgModule({
  imports: [
    CommonModule,
    ProfileListHeaderModule,
    ProfileListCardModule,
    ProfileListSearchSortModule,
    ProfileListFiltersModule,
    SpotlightProfilesStoreModule,
    AccrediblePaginationModule,
    TranslocoModule,
    ...MATERIAL_MODULES,
    RouterModule.forChild(routes),
    ProfileListNoResultsComponent,
    LetDirective,
  ],
  exports: [],
  declarations: [ProfileListContainer],
  providers: [FilterService],
})
export class ProfileListContainerModule {}
